import React from "react";
import "./NPSCardHead.css";

// Replicates the design's `.card-head` row: title + note inline on the left,
// optional controls pinned to the right (`right`), wrapping on narrow screens.
const NPSCardHead = ({ title, note, right }) => (
  <div className="nps-card-head">
    <h2 className="nps-card-title">{title}</h2>
    {note && <p className="nps-card-note">{note}</p>}
    {right && <div className="nps-card-head-right">{right}</div>}
  </div>
);

export default NPSCardHead;
